import React from "react";
import Custombutton from "../../utils/Custombutton";
import { ProgressBar } from "react-bootstrap";
import Header from "../layouts/Header/Header";

const Tracking = () => {
  return (
    <div>
      <div className="buying pt-3 px-3">
        <Header />
        <div className="container h-100 pt-5">
          <div className="row h-100 pt-5">
            <div className="col-lg-5 mb-5">
              <img className="w-100" src="/assets/images/track.png" alt="" />
              <div className="text-center d-flex align-items-center justify-content-center mt-5">
                <Custombutton
                  label={"Order id : 22222 "}
                  className={"btn-bg px-5 py-3 w-75"}
                />
              </div>
            </div>
            <div className="col-lg-7  mb-5">
              <h1>Order Status</h1>
              <div className="row mt-5 mb-5">
                <div className="col-lg-3 text-center mb-3">
                  <p>Payment</p>
                  <ProgressBar now={60} />
                </div>
                <div className="col-lg-5 text-center mb-3">
                  <p>Order Tracking</p>
                  <ProgressBar now={60} />
                </div>
                <div className="col-lg-4 text-center mb-3">
                  <p>Order Delivered</p>
                  <ProgressBar now={60} />
                </div>
              </div>
              <h1 style={{ fontSize: "30px" }}>Details</h1>
              <div className="row mt-5 details-order align-items-center">
                <div className="col-lg-3 mb-3">
                  <p>14 DEC 15:50</p>
                </div>
                <div className="col-lg-1 mb-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="43"
                    height="43"
                    viewBox="0 0 43 43"
                    fill="none"
                  >
                    <circle
                      cx="21.8068"
                      cy="21.2854"
                      r="17.4084"
                      fill="#0B0B0B"
                    />
                    <path
                      d="M29.2532 16.4446C29.3746 16.5658 29.4709 16.7098 29.5366 16.8683C29.6023 17.0268 29.6361 17.1967 29.6361 17.3683C29.6361 17.5399 29.6023 17.7098 29.5366 17.8683C29.4709 18.0268 29.3746 18.1708 29.2532 18.292L20.1138 27.4315C19.9925 27.5529 19.8485 27.6492 19.69 27.7149C19.5315 27.7806 19.3616 27.8144 19.1901 27.8144C19.0185 27.8144 18.8486 27.7806 18.6901 27.7149C18.5316 27.6492 18.3876 27.5529 18.2663 27.4315L14.3494 23.5146C14.1045 23.2696 13.9668 22.9373 13.9668 22.5908C13.9668 22.2444 14.1045 21.9121 14.3494 21.6671C14.5944 21.4221 14.9267 21.2845 15.2732 21.2845C15.6196 21.2845 15.9519 21.4221 16.1969 21.6671L19.1901 24.6619L27.4057 16.4446C27.527 16.3232 27.671 16.2269 27.8295 16.1612C27.988 16.0955 28.1579 16.0617 28.3295 16.0617C28.5011 16.0617 28.671 16.0955 28.8295 16.1612C28.988 16.2269 29.132 16.3232 29.2532 16.4446ZM38.7745 21.2852C38.7745 24.6422 37.7791 27.9238 35.914 30.715C34.049 33.5062 31.3981 35.6817 28.2967 36.9664C25.1952 38.2511 21.7825 38.5872 18.49 37.9323C15.1975 37.2774 12.1732 35.6608 9.79947 33.2871C7.42572 30.9133 5.80918 27.889 5.15427 24.5965C4.49935 21.304 4.83548 17.8913 6.12014 14.7898C7.4048 11.6884 9.5803 9.03755 12.3715 7.17251C15.1628 5.30747 18.4443 4.31201 21.8013 4.31201C26.3014 4.31676 30.6159 6.10653 33.7979 9.28859C36.98 12.4707 38.7698 16.7851 38.7745 21.2852ZM36.1633 21.2852C36.1633 18.4447 35.3209 15.668 33.7428 13.3061C32.1647 10.9443 29.9217 9.10353 27.2974 8.01651C24.6731 6.92949 21.7854 6.64507 18.9995 7.19923C16.2135 7.75339 13.6545 9.12123 11.6459 11.1298C9.63735 13.1383 8.26951 15.6974 7.71535 18.4833C7.1612 21.2693 7.44561 24.157 8.53263 26.7813C9.61965 29.4056 11.4605 31.6486 13.8223 33.2267C16.1841 34.8048 18.9608 35.6471 21.8013 35.6471C25.609 35.6428 29.2595 34.1283 31.952 31.4359C34.6444 28.7434 36.1589 25.0929 36.1633 21.2852Z"
                      fill="#777777"
                    />
                  </svg>
                </div>
                <div className="col-lg-8 mb-3">
                  <div>
                    <p>On its way to Delivery Facility</p>
                    <p>
                      ft.•ur order on Its way to wow nearest delivery tac'.ry
                      With tracking number PK DEA : IL abore • Kot Lakh Patl
                    </p>
                  </div>
                </div>
              </div>{" "}
              <div className="row mt-5 details-order align-items-center">
                <div className="col-lg-3 mb-3">
                  <p>14 DEC 15:50</p>
                </div>
                <div className="col-lg-1 mb-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="43"
                    height="43"
                    viewBox="0 0 43 43"
                    fill="none"
                  >
                    <circle
                      cx="21.8068"
                      cy="21.2854"
                      r="17.4084"
                      fill="#0B0B0B"
                    />
                    <path
                      d="M29.2532 16.4446C29.3746 16.5658 29.4709 16.7098 29.5366 16.8683C29.6023 17.0268 29.6361 17.1967 29.6361 17.3683C29.6361 17.5399 29.6023 17.7098 29.5366 17.8683C29.4709 18.0268 29.3746 18.1708 29.2532 18.292L20.1138 27.4315C19.9925 27.5529 19.8485 27.6492 19.69 27.7149C19.5315 27.7806 19.3616 27.8144 19.1901 27.8144C19.0185 27.8144 18.8486 27.7806 18.6901 27.7149C18.5316 27.6492 18.3876 27.5529 18.2663 27.4315L14.3494 23.5146C14.1045 23.2696 13.9668 22.9373 13.9668 22.5908C13.9668 22.2444 14.1045 21.9121 14.3494 21.6671C14.5944 21.4221 14.9267 21.2845 15.2732 21.2845C15.6196 21.2845 15.9519 21.4221 16.1969 21.6671L19.1901 24.6619L27.4057 16.4446C27.527 16.3232 27.671 16.2269 27.8295 16.1612C27.988 16.0955 28.1579 16.0617 28.3295 16.0617C28.5011 16.0617 28.671 16.0955 28.8295 16.1612C28.988 16.2269 29.132 16.3232 29.2532 16.4446ZM38.7745 21.2852C38.7745 24.6422 37.7791 27.9238 35.914 30.715C34.049 33.5062 31.3981 35.6817 28.2967 36.9664C25.1952 38.2511 21.7825 38.5872 18.49 37.9323C15.1975 37.2774 12.1732 35.6608 9.79947 33.2871C7.42572 30.9133 5.80918 27.889 5.15427 24.5965C4.49935 21.304 4.83548 17.8913 6.12014 14.7898C7.4048 11.6884 9.5803 9.03755 12.3715 7.17251C15.1628 5.30747 18.4443 4.31201 21.8013 4.31201C26.3014 4.31676 30.6159 6.10653 33.7979 9.28859C36.98 12.4707 38.7698 16.7851 38.7745 21.2852ZM36.1633 21.2852C36.1633 18.4447 35.3209 15.668 33.7428 13.3061C32.1647 10.9443 29.9217 9.10353 27.2974 8.01651C24.6731 6.92949 21.7854 6.64507 18.9995 7.19923C16.2135 7.75339 13.6545 9.12123 11.6459 11.1298C9.63735 13.1383 8.26951 15.6974 7.71535 18.4833C7.1612 21.2693 7.44561 24.157 8.53263 26.7813C9.61965 29.4056 11.4605 31.6486 13.8223 33.2267C16.1841 34.8048 18.9608 35.6471 21.8013 35.6471C25.609 35.6428 29.2595 34.1283 31.952 31.4359C34.6444 28.7434 36.1589 25.0929 36.1633 21.2852Z"
                      fill="#777777"
                    />
                  </svg>
                </div>
                <div className="col-lg-8 mb-3">
                  <div>
                    <p>On its way to Delivery Facility</p>
                    <p>
                      ft.•ur order on Its way to wow nearest delivery tac'.ry
                      With tracking number PK DEA : IL abore • Kot Lakh Patl
                    </p>
                  </div>
                </div>
              </div>
              <div className="row mt-5 details-order align-items-center">
                <div className="col-lg-3 mb-3">
                  <p>14 DEC 15:50</p>
                </div>
                <div className="col-lg-1 mb-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="43"
                    height="43"
                    viewBox="0 0 43 43"
                    fill="none"
                  >
                    <circle
                      cx="21.8068"
                      cy="21.2854"
                      r="17.4084"
                      fill="#0B0B0B"
                    />
                    <path
                      d="M29.2532 16.4446C29.3746 16.5658 29.4709 16.7098 29.5366 16.8683C29.6023 17.0268 29.6361 17.1967 29.6361 17.3683C29.6361 17.5399 29.6023 17.7098 29.5366 17.8683C29.4709 18.0268 29.3746 18.1708 29.2532 18.292L20.1138 27.4315C19.9925 27.5529 19.8485 27.6492 19.69 27.7149C19.5315 27.7806 19.3616 27.8144 19.1901 27.8144C19.0185 27.8144 18.8486 27.7806 18.6901 27.7149C18.5316 27.6492 18.3876 27.5529 18.2663 27.4315L14.3494 23.5146C14.1045 23.2696 13.9668 22.9373 13.9668 22.5908C13.9668 22.2444 14.1045 21.9121 14.3494 21.6671C14.5944 21.4221 14.9267 21.2845 15.2732 21.2845C15.6196 21.2845 15.9519 21.4221 16.1969 21.6671L19.1901 24.6619L27.4057 16.4446C27.527 16.3232 27.671 16.2269 27.8295 16.1612C27.988 16.0955 28.1579 16.0617 28.3295 16.0617C28.5011 16.0617 28.671 16.0955 28.8295 16.1612C28.988 16.2269 29.132 16.3232 29.2532 16.4446ZM38.7745 21.2852C38.7745 24.6422 37.7791 27.9238 35.914 30.715C34.049 33.5062 31.3981 35.6817 28.2967 36.9664C25.1952 38.2511 21.7825 38.5872 18.49 37.9323C15.1975 37.2774 12.1732 35.6608 9.79947 33.2871C7.42572 30.9133 5.80918 27.889 5.15427 24.5965C4.49935 21.304 4.83548 17.8913 6.12014 14.7898C7.4048 11.6884 9.5803 9.03755 12.3715 7.17251C15.1628 5.30747 18.4443 4.31201 21.8013 4.31201C26.3014 4.31676 30.6159 6.10653 33.7979 9.28859C36.98 12.4707 38.7698 16.7851 38.7745 21.2852ZM36.1633 21.2852C36.1633 18.4447 35.3209 15.668 33.7428 13.3061C32.1647 10.9443 29.9217 9.10353 27.2974 8.01651C24.6731 6.92949 21.7854 6.64507 18.9995 7.19923C16.2135 7.75339 13.6545 9.12123 11.6459 11.1298C9.63735 13.1383 8.26951 15.6974 7.71535 18.4833C7.1612 21.2693 7.44561 24.157 8.53263 26.7813C9.61965 29.4056 11.4605 31.6486 13.8223 33.2267C16.1841 34.8048 18.9608 35.6471 21.8013 35.6471C25.609 35.6428 29.2595 34.1283 31.952 31.4359C34.6444 28.7434 36.1589 25.0929 36.1633 21.2852Z"
                      fill="#777777"
                    />
                  </svg>
                </div>
                <div className="col-lg-8 mb-3">
                  <div>
                    <p>On its way to Delivery Facility</p>
                    <p>
                      ft.•ur order on Its way to wow nearest delivery tac'.ry
                      With tracking number PK DEA : IL abore • Kot Lakh Patl
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tracking;
